import {
  withTranslation,
} from 'react-i18next';

import RegionsListView from './RegionsListView';

const TranslatedComponent = withTranslation()(RegionsListView);

const Component = TranslatedComponent;

export default Component;
